import { memo } from "react";
// eslint-disable-next-line import/no-unresolved
import { CloseButtonProps } from "react-toastify/dist/components";
import CloseIconToast from "assets/icons/close-grey.svg?react";
import "./styles.sass";

const ToastButtonClose = ({ closeToast }: CloseButtonProps) => {
  return (
    // eslint-disable-next-line react/jsx-handler-names
    <button onClick={closeToast} type="button" className="ToastButtonClose">
      <CloseIconToast className="ToastButtonClose__icon" />
    </button>
  );
};

export default memo(ToastButtonClose);
